import React, { useState } from 'react';
import { folderService } from '../../../services/api';
import { Folder } from '../../../types';

interface EditFolderModalProps {
  folder: Folder;
  onClose: () => void;
  onSuccess: (updatedFolder: Folder) => void;
}

const EditFolderModal: React.FC<EditFolderModalProps> = ({ folder, onClose, onSuccess }) => {
  const [folderName, setFolderName] = useState(folder.name);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!folderName.trim()) {
      setError('El nombre de la carpeta es requerido');
      return;
    }

    if (folderName.trim() === folder.name) {
      onClose(); // No hay cambios
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await folderService.updateFolder(folder.pk_folder, folderName.trim());
      if (response.success) {
        onSuccess((response as any).folder);
      } else {
        setError(response.error || 'Error al actualizar la carpeta');
      }
    } catch (error) {
      console.error('Error updating folder:', error);
      setError('Error al actualizar la carpeta');
    } finally {
      setLoading(false);
    }
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h2>Editar Carpeta</h2>
          <button onClick={onClose} className="close-btn">
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="folderName">Nombre de la carpeta</label>
            <input
              type="text"
              id="folderName"
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              placeholder="Ingresa el nuevo nombre"
              disabled={loading}
              autoFocus
            />
          </div>

          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-secondary"
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? 'Guardando...' : 'Guardar Cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditFolderModal;